'use strict';

// Pen test 2026-53 V6: the post-logout redirect sent to the identity provider comes from the deployed settings.js
// (OIDC_POST_LOGOUT_REDIRECT_URI, substituted by the release pipeline) and must be an absolute http(s) URL on this
// app's own origin. Anything else falls back to the app origin. That covers a missing value, an unsubstituted "$(...)",
// another origin, a protocol-relative value, an alternate scheme and an encoded value.
// The real control is the B2C policy (docs/security/pentest-2026-53-v6-b2c-logout.md).
export function resolvePostLogoutRedirectUri(configured, origin) {
    const fallback = origin + '/';

    if (typeof configured !== 'string' || configured.indexOf('$(') !== -1 || !/^https?:\/\//i.test(configured)) {
        return fallback;
    }

    let url;
    try {
        url = new URL(configured);
    } catch (e) {
        return fallback;
    }

    return url.origin === origin ? url.href : fallback;
}
